export const removeMetadata = (id: string) => {
    if (typeof window === "undefined") {
        return;
    }

    const scriptTag = document.getElementById(id);
    if (scriptTag) {
        scriptTag.remove();
    }
};

export const injectMetadata = (metadata: string, id: string) => {
    if (typeof window === "undefined") {
        return;
    }

    let jsonLdScript = document.querySelector('script[type="application/ld+json"]:not([id])');
    if (!jsonLdScript) {
        jsonLdScript = document.createElement("script");
        jsonLdScript.setAttribute("type", "application/ld+json");
        document.head.appendChild(jsonLdScript);
    }

    let scriptTag = document.getElementById(id);
    if (scriptTag) {
        scriptTag.innerHTML = metadata;
    } else {
        scriptTag = document.createElement("script");
        scriptTag.setAttribute("type", "application/ld+json");
        scriptTag.id = id;
        scriptTag.innerHTML = metadata;
        document.head.appendChild(scriptTag);
    }
};
